import axios from 'axios';

export interface PartnerShopDetailShop {
  id: number;
  name: string;
  category: string[];
  description: string;
  location: string;
  reviewCount: number;
  photoCount: number;
  verified: boolean;
}

export interface PartnerShopDetailHeroImages {
  mobile: string;
  desktop: string;
  gallery: string[];
}


export interface PartnerShopDetailTextItem {
  title: string;
  desc: string;
}

export interface PartnerSummarySection {
  introText: string;
  items: PartnerShopDetailTextItem[]
}

export interface PartnerShopDetailInsightItem {
  title: string;
  description: string;
}

export interface PartnerShopDetailBrandStory {
  description: string;
  points: PartnerShopDetailTextItem[];
}

export interface PartnerShopDetailReviewPhoto {
  id: number | string;
  src: string;
  label: string;
  category: string;
}

export interface PartnerShopDetailReviewSummary {
  totalReviewCount: number;
  quote: string;
  pros: PartnerShopDetailInsightItem[];
  notes: PartnerShopDetailInsightItem[];
}

export interface PartnerShopDetailProduct {
  title: string;
  desc: string;
  price: string;
}

export interface PartnerShopDetailFaq {
  question: string;
  answer: string;
}

export interface PartnerShopDetailInfoItem {
  label: string;
  value: string;
}

export interface PartnerShopDetailBenefit {
  title: string;
  condition: string;
  badge?: string;
}

export interface PartnerShopDetailVendorBenefits {
  vendorName: string;
  vendorCategory: string;
  benefits: PartnerShopDetailBenefit[];
}
const a = {"introText": "신랑님, 신부님! 강남 최대 규모와 합리적인 가격을 모두 잡은 헤리츠테일러를 추천드리는 6가지 핵심 이유를 더 간결하게 정리해 드릴게요.\n\n헤리츠테일러는 넓고 쾌적한 매장에서 프라이빗한 상담이 가능하며, 이태리 원단 맞춤 시 89만원부터 시작하는 합리적인 가격대로 신랑님들께 인기가 정말 많아요. 실제 고객님들의 만족도가 높은 포인트만 콕 집어서 안내해 드릴게요.", items:[{"title": "높은 맞춤 예복 완성도", "description": "고객들은 맞춤 예복의 퀄리티와 핏에 대해 매우 만족하고 있습니다."}, {"title": "친절한 상담 및 세심한 체크", "description": "상담 과정에서의 친절함과 세밀한 체크가 긍정적으로 언급되었습니다."}, {"title": "다양한 대여 옵션 및 소품 제공", "description": "촬영용 예복 대여 시 다양한 색상과 소품이 제공되어 만족도가 높습니다."}, {"title": "편리한 픽업 및 반납 시스템", "description": "대여 예복의 픽업과 반납이 간편하다는 점이 고객들에게 호평받고 있습니다."}, {"title": "고급스러운 원단 사용", "description": "고급 원단을 사용하여 예복의 질감과 착용감이 뛰어나다는 평가가 많습니다."}]}

export interface PartnerShopDetailPageData {
  shop: PartnerShopDetailShop;
  heroImages: PartnerShopDetailHeroImages;
  brandStory: PartnerShopDetailBrandStory;
  verifiedReasonsJson: PartnerSummarySection;
  promotionBenefits: PartnerShopDetailVendorBenefits[];
  reviewPhotos: PartnerShopDetailReviewPhoto[];
  reviewSummary: PartnerShopDetailReviewSummary;
  brandLookbook: string[];
  products: PartnerShopDetailProduct[];
  faqs: PartnerShopDetailFaq[];
  information: PartnerShopDetailInfoItem[];
}

export async function getPartnerShopDetail(shopSlug: string, options?: { preview?: boolean }) {
  const response = await axios.get(`/api/partner-shops/${shopSlug}`, {
    params: {
      preview: options?.preview ? 1 : undefined,
    },
  });

  const result = response.data;

  if (!result || result.status !== 200) {
    throw new Error(result?.message || '업체 상세 정보를 불러오지 못했습니다.');
  }

  return result.data as PartnerShopDetailPageData;
}



export interface PartnerShopReviewInsight {
  title: string;
  description: string;
}

export interface PartnerShopReviewItem {
  id: number;
  title: string;
  date: string;
  source: string;
  summary: string;
  photoThumbnails: string[];
  contentPreview: string;
  tags: string[];
  goodPoints: string[];
  checkPoints: string[];
  originalUrl: string;
  evaluationLevel?: string | null;
  sentiment?: string | null;
  confidence?: number | null;
}

export interface PartnerShopReviewPageData {
  shop: {
    id: number;
    name: string;
    slug: string;
    category: string[];
    description: string;
    location: string;
    verified: boolean;
  };

  overview: {
    total: number;
    evaluated: number;
    direct: number;
    indirect: number;
    mentionedOnly: number;
  };

  summary: {
    totalReviewCount: number;
    quote: string;
    pros: PartnerShopReviewInsight[];
    notes: PartnerShopReviewInsight[];
  };

  filters: Array<{
    label: string;
    count: number;
  }>;
  positiveBars: Array<{ label: string; count: number }>;
  cautionBars: Array<{ label: string; count: number }>;
  checkTips: string[];

  reviews: PartnerShopReviewItem[];
}

export async function getPartnerShopReviews(
  shopSlug: string,
  options?: {
    preview?: boolean;
  }
) {
  const response = await axios.get(`/api/partner-shops/${shopSlug}/reviews`, {
    params: {
      preview: options?.preview ? 1 : undefined,
    },
  });

  const result = response.data;

  if (!result || result.status !== 200) {
    throw new Error(result?.message || '후기 정보를 불러오지 못했습니다.');
  }

  return result.data as PartnerShopReviewPageData;
}





export interface PartnerShopLookbookPartnerShop {
  id: number;
  shopName: string;
  displayName: string;
  shopSlug: string;
  shopCategory: string;
  shortDescription?: string;
}

export interface LookbookCategory {
  id: string;
  label: string;
  description?: string;
  count: number;
  sortOrder?: number;
}

export interface LookbookPhoto {
  id: string;
  category: string;
  categoryLabel: string;
  title: string;
  description: string;
  src: string;
  thumbnailSrc?: string;
  isRepresentative?: number;
  sortOrder?: number;
}

export interface PartnerShopLookbookData {
  partnerShop: PartnerShopLookbookPartnerShop;
  categories: LookbookCategory[];
  photos: LookbookPhoto[];
}

export async function getPartnerShopLookbookBySlug(
  shopSlug: string
): Promise<PartnerShopLookbookData> {
  const response = await fetch(
    `/api/partner-shops/${encodeURIComponent(shopSlug)}/lookbook`
  );

  const result = await response.json();

  if (!response.ok || result.status !== 200) {
    throw new Error(result.message || '룩북을 불러오지 못했습니다.');
  }

  return result.data;
}